import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Loader from "../../../../components/Loader"
import { useRequest } from "../../../../hooks/useRequest"
import { openSupportChat, refreshSupportUser } from "../../../../lib/chatwoot"
import { appStore } from "../../../../store/appStore"
import { userStore } from "../../../../store/userStore"
import { User } from "../../../../types/entities/user"

function useIsDesktop() {
    const [isDesktop, setIsDesktop] = useState(() => window.matchMedia("(min-width: 768px)").matches)

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 768px)")
        const onChange = () => setIsDesktop(mediaQuery.matches)

        mediaQuery.addEventListener("change", onChange)
        return () => mediaQuery.removeEventListener("change", onChange)
    }, [])

    return isDesktop
}

export default function Support() {
    const navigate = useNavigate()
    const { user, setUser, deviceToken } = userStore()
    const { city, cinema } = appStore()
    const { request } = useRequest()
    const isDesktop = useIsDesktop()

    useEffect(() => {
        if (isDesktop) return

        let active = true

        const start = async () => {
            const currentUser = await refreshSupportUser(user, () =>
                request<User>("GET", `user?city_id=${city.id}`, undefined, { disableError: true })
            )
            if (!active) return
            if (currentUser) setUser(currentUser)

            await openSupportChat({
                user: currentUser,
                deviceToken,
                cityId: city.id,
                cityName: city.name,
                cinemaName: cinema.name
            })

            if (active) navigate("/profile", { replace: true })
        }

        start().catch(console.error)

        return () => {
            active = false
        }
    }, [isDesktop, user?.id, deviceToken, city.id, city.name, cinema.name, navigate])

    if (isDesktop) return null

    return (
        <div className="flex min-h-[200px] items-center justify-center">
            <Loader frame />
        </div>
    )
}
